// Loading placeholder that mirrors the ResourceCardV2 layout: a 16:9 thumbnail,
// the taxonomy/badge header row, a two-line title, a three-line description, and
// the type + "View" footer.
export function ResourceCardV2Skeleton() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 overflow-hidden h-full flex flex-col animate-pulse">
      {/* Thumbnail */}
      <div className="relative aspect-video bg-gray-200 dark:bg-gray-700" />

      {/* Content */}
      <div className="p-4 flex flex-col flex-1">
        {/* Taxonomy label + trade badge */}
        <div className="flex items-start justify-between gap-2">
          <div className="h-3 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-4 w-16 shrink-0 bg-gray-200 dark:bg-gray-700 rounded-full" />
        </div>

        {/* Title (2 lines) */}
        <div className="mt-3 space-y-2">
          <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-4 w-3/4 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>

        {/* Description (3 lines) */}
        <div className="mt-3 space-y-2">
          <div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-3 w-2/3 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>

        {/* Footer: type + View */}
        <div className="mt-auto pt-4 flex items-center justify-between">
          <div className="h-3 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-3 w-10 bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
      </div>
    </div>
  );
}
